module.exports = __webpack_public_path__ + "static/img/p1.4552122.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robot/LMG1/p1.png
// module id = SPQk
// module chunks = 7